// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './style/element-variables.scss'
import VueCookies from 'vue-cookies'
import axios from 'axios'
import App from './App'
import router from './router'
import store from '@/store/index'
import globalFunc from '@/utils/globalFunc'
import { preventReClick } from '@/utils/plugins';
import storage from '@/router/router'
import bus from "./utils/bus.js"

Vue.use(ElementUI);
Vue.use(VueCookies);
Vue.use(globalFunc)

Vue.config.productionTip = false
Vue.prototype.$http = axios
Vue.prototype.$store = store
Vue.prototype.$storage = storage
Vue.prototype.$bus = bus;  //在实例中注册使用  这下所有的vue组件都可以使用了
Vue.prototype.validSe = function (value) {
    // 处理规则
    return value.replace(/[^\d]/g, '');
}
axios.defaults.withCredentials = true;
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
axios.defaults.retry = 3;
axios.defaults.retryDelay = 1000;
axios.defaults.shouldRetry = (error) => true;
axios.defaults.baseURL = '/'
// 请求
axios.interceptors.request.use((config) => {
    return config
}, (error) => {
    ElementUI.Message({
        message: `请求超时`,
        type: 'error'
    })
    return Promise.reject(error)
})
// 添加一个响应拦截器
axios.interceptors.response.use(function (res) {
    let statusCode = res.data.code;
    if (res.data.code == undefined || res.data.code == 1000) {
        return res
    }
    else if (res.data.code == 400) {
        return res
    } else if (statusCode === 20001) {
        store.state.userData = {};
        router.replace({ path: "/login" });
        sessionStorage.clear();
        localStorage.clear();
    } else {
        ElementUI.Message({
            message: res.data.message,
            type: 'error'
        })
    }

}, error => {
    if (error.response && error.response.status && error.response.status == 504) {
        ElementUI.Message.error('服务器错误');
    }
    // if (error == '操作过频') {
    //     globalFunc.debounce(() => { ElementUI.Message.error(error) }, msgRelay);
    // }
    return Promise.reject(error)
})


/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js